const BODY_SIZE: string = '20';
const TYPE_SCALE: number = 1.2625; // major second
const TYPE_BREAKPOINT_SCALE: number = 1.2625; // major second

export {
  BODY_SIZE,
  TYPE_SCALE,
  TYPE_BREAKPOINT_SCALE,
};
